import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useLocalization } from "@progress/kendo-react-intl";
import { MissionStatusChart } from "../components/synchro/MissionStatusChart";
import { MissionSpostaChart } from "../components/synchro/MissionSpostaChart";
import { MissionAbbassChart } from "../components/synchro/MissionAbbassChart";
import { MissionStockChart } from "../components/synchro/MissionStockChart";
import { MissionPalpieChart } from "../components/synchro/MissionPalpieChart";
import { ForkliftsChart } from "../components/synchro/ForkliftsChart";
import { PriorityValuesChart } from "../components/synchro/PriorityValuesChart";
import { ServerStatus } from "../components/synchro/ServerStatus";
import { HealthChecker } from "../components/synchro/HealthChecker";
import { Efficiency } from "../components/synchro/Efficiency";

export const Synchro = (props: any) => {

    const localizationService = useLocalization();

    return (
        <div className="grid-layout-container"
            style={{ display: 'flex', background: '#F6F6F6' }}>
            <GridLayout
                //gap={{rows: 6, cols: 4}}
                //rows={[{height: 10}, {height: 100}, {height: 100}, {height: 20}, {height: 660}]}
                cols={[{ width: 180 }, { width: 120 }, { width: 100 }]}
                style={{ borderRadius: '16px', width: '70%', background: 'white', padding: '10px', margin: '10px' }}
            >

                <div className="k-text-inverse k-text-uppercase k-font-weight-bold">
                    <p style={{color:'#34A3B7'}}>{localizationService.toLanguageString('synchro.missions_title', 'NOT_FOUND')}</p>
                </div>                

                <GridLayoutItem row={2} col={1} colSpan={3}>
                    <MissionStatusChart />
                </GridLayoutItem>

                <GridLayoutItem row={2} col={4}>
                    <MissionPalpieChart />
                </GridLayoutItem>

                <GridLayoutItem row={2} col={5}>
                    <MissionStockChart />
                </GridLayoutItem>

                <GridLayoutItem row={3} col={4}>
                    <MissionAbbassChart />
                </GridLayoutItem>

                <GridLayoutItem row={3} col={5}>
                    <MissionSpostaChart />
                </GridLayoutItem>

                <GridLayoutItem row={5} col={1} colSpan={5}>
                    <div style={{textAlign: 'center', borderTop: '1px solid #ededed' }}>
                        <div className="k-text-inverse k-text-uppercase k-font-weight-bold" style={{marginTop: '20px'}}>
                            <p style={{color:'#34A3B7'}}>{localizationService.toLanguageString('synchro.priority_value_per_missions_state', 'NOT_FOUND')}</p>
                        </div>
                        <PriorityValuesChart /> 
                    </div>
                </GridLayoutItem>

            </GridLayout>

            <div style={{ display: 'inline-grid', width: '30%' }} >

                <GridLayout
                    style={{ borderRadius: '16px', background: 'white', padding: '10px', margin: '10px' }}
                >
                    <GridLayoutItem row={1} col={1} style={{textAlign: 'center'}}>
                        <div className="k-text-inverse k-text-uppercase k-font-weight-bold" >
                            <p style={{textAlign: 'left', color:'#34A3B7'}}>{localizationService.toLanguageString('synchro.efficiency', 'NOT_FOUND')}</p>
                        </div>       
                        <Efficiency />                
                    </GridLayoutItem>
                </GridLayout>

                <GridLayout
                    style={{ borderRadius: '16px', background: 'white', padding: '10px', margin: '10px' }}
                >
                    <GridLayoutItem row={1} col={1}>
                        <div className="k-text-inverse k-text-uppercase k-font-weight-bold">
                            <p style={{textAlign: 'left', color:'#34A3B7'}}>{localizationService.toLanguageString('synchro.forklift', 'NOT_FOUND')}</p>
                        </div>
                    </GridLayoutItem>
                    <GridLayoutItem row={2} col={1}>
                        <ForkliftsChart />
                    </GridLayoutItem>
                </GridLayout>
                
                <GridLayout
                    style={{ borderRadius: '16px', background: 'white', padding: '10px', margin: '10px' }}
                >
                    <GridLayoutItem row={1} col={1}>
                        <div className="k-text-inverse k-text-uppercase k-font-weight-bold">
                            <p style={{textAlign: 'left', color:'#34A3B7'}}>{localizationService.toLanguageString('synchro.server_status', 'NOT_FOUND')}</p>
                        </div>
                    </GridLayoutItem>
                    <GridLayoutItem row={2} col={1}>
                        <ServerStatus />
                    </GridLayoutItem>
                </GridLayout>
                
                <GridLayout
                    style={{ borderRadius: '16px', background: 'white', padding: '10px', margin: '10px' }}
                >
                    <GridLayoutItem row={1} col={1}>
                        <div className="k-text-inverse k-text-uppercase k-font-weight-bold">
                            <p style={{color:'#34A3B7'}}>HEALTH CHECKER</p>
                        </div>
                    </GridLayoutItem>
                    <GridLayoutItem row={2} col={1}>
                        <HealthChecker />
                    </GridLayoutItem>
                </GridLayout>

            </div>

        </div>
    )
}